import { ComponentType } from 'react';
import { NewWarehousePromotionContent as NewWarehouseSwissboxPromotionContent } from 'widgets/NewWarehouseSwissboxPromotion';
import { NewWarehousePromotionContent } from 'widgets/NewWarehousePromotion';

const promotionContentMapper: Record<string, ComponentType> = {
  swissbox: NewWarehouseSwissboxPromotionContent,
  rentabox24de: NewWarehousePromotionContent,
  rentabox24at: NewWarehousePromotionContent,
  rentabox24pl: NewWarehousePromotionContent,
};

export const getPromotionContentByClient = (clientName?: string): ComponentType => {
  if (!clientName) {
    return promotionContentMapper.swissbox;
  }

  return promotionContentMapper[clientName];
};
